/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_PrintInputs */

const en_pc_online_cmp_print = /** @type {(inputs: Pc_Online_Cmp_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Printing`)
};

const zh_pc_online_cmp_print = /** @type {(inputs: Pc_Online_Cmp_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打印`)
};

/**
* | output |
* | --- |
* | "Printing" |
*
* @param {Pc_Online_Cmp_PrintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_print = /** @type {((inputs?: Pc_Online_Cmp_PrintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_PrintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_print(inputs)
	return zh_pc_online_cmp_print(inputs)
});
export { pc_online_cmp_print as "pc.online.cmp.print" }